module.exports = __webpack_public_path__ + "static/img/samia.e8a33ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/samia.jpg
// module id = wYkA
// module chunks = 0